import { ViewStyle } from 'react-native';

const scrollContainer: ViewStyle = {
    flexDirection: 'row',
    width: '100%'
};
const scrollViewContainer: ViewStyle = {
    width: '100%'
};
const customScrollBar: ViewStyle = {
    backgroundColor: '#ccc',
    borderRadius: 3,
    width: 6
};
const customScrollBarBackground: ViewStyle = {
    backgroundColor: '#232323',
    borderRadius: 3,
    height: '100%',
    width: 6
};

export default {
    scrollContainer,
    scrollViewContainer,
    customScrollBar,
    customScrollBarBackground
};
